import { ScreenDefinition } from 'src/ui/common/screens/ScreenDefinition';
import { ERIS_Screen } from './ErisScreen';
import LoginPage from 'src/pages/LoginPage';
import AuthCallbackPage from 'src/pages/AuthCallbackPage';
import ErisMain from '../screens/main/ErisMain';
import ErisHistory from '../screens/main/components/history/ErisHistory';
import { getAuthRedirectPathname } from 'src/auth/authConfig';

export const ErisScreensMap: Record<ERIS_Screen, ScreenDefinition> = {
  [ERIS_Screen.Main]: {
    key: ERIS_Screen.Main,
    path: 'main',
    mobileComponent: <ErisMain />,
  },
  [ERIS_Screen.Login]: {
    key: ERIS_Screen.Login,
    path: 'login',
    mobileComponent: <LoginPage />,
  },
  [ERIS_Screen.AuthCallback]: {
    key: ERIS_Screen.AuthCallback,
    path: getAuthRedirectPathname().replace(/^\//, ''),
    mobileComponent: <AuthCallbackPage />,
  },
  [ERIS_Screen.History]: {
    key: ERIS_Screen.History,
    path: 'history',
    mobileComponent: <ErisHistory />,
  },
};
